/* tslint:disable */

declare var Object: any;
export interface SFAttendanceSF6Interface {
  "id"?: number;
}

export class SFAttendanceSF6 implements SFAttendanceSF6Interface {
  "id": number;
  constructor(data?: SFAttendanceSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttendanceSF6`.
   */
  public static getModelName() {
    return "SFAttendanceSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttendanceSF6 for dynamic purposes.
  **/
  public static factory(data: SFAttendanceSF6Interface): SFAttendanceSF6{
    return new SFAttendanceSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttendanceSF6',
      plural: 'SFAttendanceSF6s',
      path: 'SFAttendanceSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttendanceSF6.ts